module.exports = __webpack_public_path__ + "img/jdate.5a46f09.svg";